export const GET_API_TOKEN_LIST = 'GET_API_TOKEN_LIST';



// WEBPACK FOOTER //
// ./src/views/Setup/ApiToken/flow/actionTypes.js